import type { ReactNode } from "react";
import { Icon } from "@/components/icons";

type IntroHeaderProps = {
  /** Material Symbols icon name shown in the dark icon block. */
  iconName: string;
  title: string;
  description: ReactNode;
};

/**
 * Page-intro card: dark icon block (grey-300 glyph on grey-950 with top
 * highlight stroke + flat-black shadow) next to a title + description, all
 * inside a white p-4 card with grey-200 border and flat shadow.
 *
 * Shared by the screening, monitoring, and batch landing pages.
 */
export function IntroHeader({ iconName, title, description }: IntroHeaderProps) {
  return (
    <div className="flex w-full items-center gap-4 rounded-[4px] border border-grey-200 bg-white p-4 shadow-flat">
      <div className="flex size-9 shrink-0 items-center justify-center rounded-[4px] border-t border-grey-900 bg-grey-950 text-grey-300 shadow-flat-black">
        <Icon name={iconName} size={20} />
      </div>
      <div className="flex min-w-0 flex-col gap-0.5">
        <h2 className="text-h4 text-black">{title}</h2>
        <p className="text-small text-grey-900">{description}</p>
      </div>
    </div>
  );
}
